import service from '../utils/request';

/**
 * 获取项目组列表
 * @param {Object} params - 查询参数
 * @param {string} params.keyword - 搜索关键词（可选）
 * @param {number} params.current - 页码（可选，默认1）
 * @param {number} params.size - 每页条数（可选，默认20）
 * @returns {Promise} - 返回项目组列表数据
 */
export function getProjectTeams(params = {}) {
  return service.get('/uic-system/dept/dept-list', {
    params: {
      deptCategory: 4,
      deptName: params.deptName || params.keyword || '',
      current: params.current || 1,
      size: params.size || 10
    }
  });
}

/**
 * 按项目组ID获取供应商列表，支持按名称搜索
 * @param {Object} params - 查询参数
 * @param {string} params.bizDept - 项目组ID
 * @param {number} params.current - 页码（可选，默认1）
 * @param {number} params.size - 每页条数（可选，默认100）
 * @param {string} params.supplierName - 供应商名称，用于搜索
 * @param {string} params.supplierCode - 供应商编码，用于搜索
 * @returns {Promise} - 返回供应商列表数据
 */
export function getSuppliersByGroupId(params = {}) {
  return service.get('/uic-system/supplier/page', {
    params: {
      current: params.current || 1,
      size: params.size || 100,
      bizDept: params.bizDept,
      supplierName: params.supplierName || ''
    }
  });
}

/**
 * 按供应商ID获取物料列表
 * @param {Object} params - 查询参数
 * @param {string} params.supplierId - 供应商ID
 * @param {number} params.current - 页码（可选，默认1）
 * @param {number} params.size - 每页条数（可选，默认20）
 * @param {string} params.materialNo - 物料编码，用于搜索
 * @returns {Promise} - 返回物料列表数据
 */
export function getMaterialsBySupplierId(params = {}) {
  return service.get('/uic-system/material/page', {
    params: {
      type: 1,
      ...(params.supplierId && { supplierId: params.supplierId }),
      ...(params.bizDept && { bizDept: params.bizDept }),
      current: params.current || 1,
      size: params.size || 20,
      isCompose: 0,
      ...(params.materialNo && { materialNo: params.materialNo })
    }
  });
}